import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { experienceData } from '../utils/constants';
import { FaExternalLinkAlt } from 'react-icons/fa';

const Experience = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.4, 0, 0.2, 1] },
    },
  };

  return (
    <section id="experience" className="section-padding">
      <motion.div
        ref={ref}
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        className="max-w-5xl mx-auto"
      >
        <motion.div variants={itemVariants} className="text-center mb-16">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-black gradient-text mb-6">
            Professional Journey
          </h2>
          <p className="text-lg sm:text-xl text-text-secondary font-light max-w-2xl mx-auto">
            Work experience and leadership roles
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          className="grid grid-cols-1 md:grid-cols-2 gap-12"
        >
          {experienceData.map((exp, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{
                y: -15,
                borderColor: 'var(--accent-primary)',
              }}
              className="bg-bg-secondary p-10 rounded-3xl border border-[rgba(76,201,240,0.1)] text-center transition-all duration-400 hover:shadow-[0_20px_50px_rgba(76,201,240,0.25)] group"
            >
              <motion.div
                whileHover={{ scale: 1.05, borderColor: 'var(--accent-primary)' }}
                className="w-32 h-32 mx-auto mb-6 rounded-2xl overflow-hidden border-2 border-[rgba(76,201,240,0.2)] transition-all duration-300"
              >
                <img
                  src={exp.image}
                  alt={exp.company}
                  className="w-full h-full object-cover"
                />
              </motion.div>

              <h3 className="text-xl sm:text-2xl font-bold text-text-primary mb-2">
                {exp.position}
              </h3>
              <p className="text-accent-primary font-semibold text-lg mb-6">
                {exp.company}
              </p>

              <motion.a
                href={exp.blogLink}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -2,
                  backgroundColor: 'var(--accent-primary)',
                  color: 'var(--bg-primary)',
                }}
                className="inline-block px-6 py-3 bg-transparent text-text-primary border border-accent-primary rounded-full text-sm font-medium transition-all duration-300 hover:shadow-[0_5px_15px_rgba(76,201,240,0.3)] flex items-center gap-2 justify-center"
              >
                <FaExternalLinkAlt />
                Learn More
              </motion.a>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Experience;
